import SuperCluster from 'supercluster';

/**
 * Wrapper function for the SuperCluster clustering library.
 *  - https://github.com/mapbox/supercluster
 * Returns a SuperCluster instance with point data loaded.
 *  - geoJSON spec: https://tools.ietf.org/html/rfc7946 
 * @param {array} geoJSONPoints - array of geoJSON 'Point' features
 * @param {object} options - SuperCluster options (see documentation/readme)
 */
function buildSuperClusterInstance(geoJSONPoints, options) {
  const defaultOptions = { radius: 80, maxZoom: 10 };
  options = Object.assign(defaultOptions, options);
  const superCluster = new SuperCluster(options);
  superCluster.load(geoJSONPoints);
  return superCluster;
}

/**
 * Returns a geoJSON point object for the given lat/lng.
 *  - geoJSON spec: https://tools.ietf.org/html/rfc7946 
 * @param {number} lat 
 * @param {number} lng 
 * @param {*} properties - custom properties to store on the object
 */
function getGeoJSONPoint(lat, lng, properties={}) {
  return {
    geometry: {
      type: 'Point',
      coordinates: [lng, lat],
      properties,
    },
  };
}

function getLatLngFromGeoJSONFeature(feature) {
  const { coordinates } = feature.geometry;
  return { lat: coordinates[1], lng: coordinates[0] };
}

function getDistance(point1, point2, callback) {
  const directionsService = new window.google.maps.DirectionsService();
  var request = {
    origin: point1,
    destination: point2,
    travelMode: window.google.maps.DirectionsTravelMode.DRIVING,
  };
  //return // to avoid overdoing it for now
  directionsService.route(request, function(response, status) {
    let distance = 1000000000;
    if (status == window.google.maps.DirectionsStatus.OK) {
      // calculate minimum distance
      for (var i = 0; i < response.routes.length; i++) {
        let route = response.routes[i];
        let routeDistance = 0;
        for (var j = 0; j < route.legs.length; j++) {
          let leg = route.legs[j];
          routeDistance += leg.distance.value;
        }
        distance = Math.min(distance, routeDistance);
      }

      let distanceInMiles = distance / 1000 * 0.621371;
      if (distanceInMiles > 100) {
        distanceInMiles = Math.round(distanceInMiles);
      }
      else {
        distanceInMiles = Math.round(distanceInMiles * 100) / 100;
      }
      callback(distanceInMiles);
    }
    else {
      callback(-1);
    }
  });
}

function getLatitudeLongitude(address, callback) {
  let geocoder = new window.google.maps.Geocoder();
  let geocode_results = {
    latitude: 0, longitude: 0,
  };
  geocoder.geocode({
    address: address,
  }, (results, status) => {
    if (status != window.google.maps.GeocoderStatus.OK) {
      return status;
    }
    geocode_results.latitude = results[0].geometry.location.lat();
    geocode_results.longitude = results[0].geometry.location.lng();

    callback(geocode_results);
  });
}

function getAddress(latitude, longitude, callback) {
  let geocoder = new window.google.maps.Geocoder();
  let geocode_results = {
    address1: '', address2: '', city: '', state: '', zip: '',
  };
  geocoder.geocode({
    'location': {
      lat: latitude,
      lng: longitude,
    },
  }, (results, status) => {
    if (status != window.google.maps.GeocoderStatus.OK) {
      return status;
    }
    const addressInfo = results[0];
    if (addressInfo && addressInfo.address_components) {
      const postalCode = addressInfo.address_components.filter(ad => {
        const type = ad.types.filter(t => {
          return t == 'postal_code';
        });
        return type.length > 0;
      });
      const country = addressInfo.address_components.filter(ad => {
        const type = ad.types.filter(t => {
          return t == 'country';
        });
        return type.length > 0;
      });
      const state = addressInfo.address_components.filter(ad => {
        const type = ad.types.filter(t => {
          return t == 'administrative_area_level_1';
        });
        return type.length > 0;
      });
      const city = addressInfo.address_components.filter(ad => {
        const type = ad.types.filter(t => {
          return t == 'locality';
        });
        return type.length > 0;
      });
      const address = addressInfo.address_components.filter(ad => {
        const type = ad.types.filter(t => {
          return t == 'street_number';
        });
        return type.length > 0;
      });
      const street = addressInfo.address_components.filter(ad => {
        const type = ad.types.filter(t => {
          return t == 'route';
        });
        return type.length > 0;
      });
      
      geocode_results.address = (address.length > 0 ? address[0].long_name : '') + ' ' + (street.length > 0 ? street[0].long_name : '');
      geocode_results.city = city.length > 0 ? city[0].long_name : '';
      geocode_results.state = state.length > 0 ? state[0].short_name : '';
      geocode_results.country = country.length > 0 ? country[0].long_name : '';
      geocode_results.zip = postalCode.length > 0 ? postalCode[0].long_name : '';
    }
    callback(geocode_results);
  });
}

export default {
  getDistance,
  getLatitudeLongitude,
  getAddress,
  buildSuperClusterInstance,
  getGeoJSONPoint,
  getLatLngFromGeoJSONFeature,
};



// WEBPACK FOOTER //
// ./src/helpers/MapsHelpers/MapsHelpers.js